import { OptimizelyExperimentsEnum } from "@/config/app-constant";
import { MedicalGateKeeperQuestions } from "@/types/MedicalTypes";

const gatekeeperSessionKey = "gk.questions";

export function saveMedicalGatekeeperQuestionsToSession(
  medicalDetails: MedicalGateKeeperQuestions
) {
  if (typeof window !== "undefined") {
    window.sessionStorage.setItem(
      gatekeeperSessionKey,
      JSON.stringify(medicalDetails)
    );
  }
}

export function getMedicalGatekeeperQuestionsFromSession(): MedicalGateKeeperQuestions | null {
  if (typeof window === "undefined") return null;
  const sessionData = window.sessionStorage.getItem(gatekeeperSessionKey);
  return sessionData ? JSON.parse(sessionData) : null;
}

export type InfoBoxType = "info" | "critical" | "warning";
export const isMedicalEligibilityFlow = () =>
  localStorage.getItem(OptimizelyExperimentsEnum.MEDICAL_ELIGIBILITY_FLOW) ===
  "variant";
